// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"313":"c3035678","349":"afb268e0","396":"6f2b160b"}[chunkId] + ".chunk.css";
};